import React from "react";
import axios from "axios";
import { Loading } from "components/common";
import { useHistory, useLocation } from "react-router-dom";
import decode from "jwt-decode";
import useMount from "utils/hooks/useMount";
import { setJwt, setUserId, setRoles } from "state/actions/user";
import { setIdleTimer } from "state/actions/idleTimer";
import { useDispatch } from "react-redux";
import { useApolloClient, useMutation } from "@apollo/react-hooks";
import { GET_CREDIT_BOOST_TRANSACTIONS, UPDATE_CREDIT_BOOST_ELIGIBILITY } from "../Boost/mutations";
import { track, identify } from "../../../utils/analytics";

const TomoBoostConfirm = () => {
  const { push } = useHistory();
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const dispatch = useDispatch();
  const client = useApolloClient();

  const updateStateWithToken = (token) => {
    window.localStorage.setItem("jwt", token);
    const { roles = {}, userid: email } = decode(token);
    dispatch(setJwt(token));
    dispatch(setIdleTimer(true, roles?.admin));
    dispatch(setRoles(roles));
    dispatch(setUserId(email));
    window.localStorage.setItem("userId", email);
  };

  const [updateCreditBoostEligibility] = useMutation(
    UPDATE_CREDIT_BOOST_ELIGIBILITY,
    {
      variables: {
        loadTransactions: true,
      },
      onCompleted: async (data) => {
        const { updateCreditBoostEligibility: response } = data || {};
        const { payees, transactions } = response;
        if (payees && transactions) {
          client.writeQuery({
            query: GET_CREDIT_BOOST_TRANSACTIONS,
            data: {
              getCreditBoostTransactions: {
                __typename: "CreditBoostTransactionsResponse",
                transactions,
                payees,
              },
            },
          });
        }

        const jwt = window.localStorage.getItem("jwt");
        const { roles = {} } = decode(jwt);

        if (!roles?.user_with_credit_boost) {
          // refresh token with boost
          try {
            const tokenRes = await axios
              .post(
                "/login/verify",
                {},
                {
                  headers: { Authorization: `Bearer ${jwt}` },
                },
              );
            const { token: newToken } = tokenRes.data || {};
            if (newToken) {
              updateStateWithToken(newToken);
            }
          } catch (err) {
            push("/login");
          }
        }

        const cmd = params.get("cmd");
        if (cmd) {
          push("/credit-monitoring");
        } else {
          push("/boost");
        }
      },
      onError: () => {
        push("/login");
      },
    },
  );

  const code = params.get("code");
  const email = params.get("email");

  useMount(() => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/verifiedlogin`, {
        code,
      })
      .then((response) => {
        track("TOMO_BOOST_DASHBOARD_LOGIN_SUCCESS", {
          user: email,
        });
        const { token } = response.data;
        updateStateWithToken(token);
        identify(email, {
          email,
        });
        updateCreditBoostEligibility();
      })
      .catch(() => {
        push("/login");
      });
  });

  return <Loading boost />;
};

export default TomoBoostConfirm;
